<template>
  <div class="board-contact-channel">
    <TopBarBack :partners-key="partnersKey" />
    <div class="contact flex flex-column mt-56">
      <div class="contact-header mb-20">
        <div class="title flex flex-align-center mx-auto">
          {{ $t('contact.title') }}
        </div>
        <div class="subtitle flex flex-align-center mx-auto">
          <el-text>
            {{ $t('contact.prefixSubtitle') }}
          </el-text>
          <el-text class="purchase-count">
            {{ $t('contact.allTile') }}
          </el-text>
          <el-text>
            {{ $t('contact.suffixSubtitle') }}
          </el-text>
        </div>
      </div>
      <ADivider />
      <div
        v-for="channel in contactChannel"
        :key="channel.title"
        class="channel flex flex-space-between flex-align-center mb-default mx-auto"
        @click="routeToChannel(channel)"
      >
        <div class="channel-text">
          <p class="channel-title">
            {{ channel.title }}
          </p>
          <p class="channel-description">
            {{ channel.desc }}
          </p>
        </div>
        <nuxt-img
          src="/img/basic-icon/right-arrow.svg"
          width="20"
          height="20"
          alt="channel"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

const { t } = useLocale()
const { navigate } = useCommon()

const props = withDefaults(
  defineProps<{
    partnersKey?: string
  }>(),
  {
    partnersKey: ''
  }
)

const contactChannel = reactive([
  {
    title: t('contact.kakao'),
    desc: t('contact.kakaoDescription'),
    url: 'https://pf.kakao.com/_fqTkK/chat'
  },
  {
    title: t('contact.email'),
    desc: t('contact.emailDescription'),
    url: '/board/email'
  }
])

const routeToChannel = (channel:any) => {
  channel.title === t('contact.kakao')
    ? navigateTo(channel.url, { external: true })
    : navigate(channel.url, props.partnersKey)
}

</script>
